<script setup lang="ts">
import { apiPathUrl } from "@/Utils/helpers";
import { toast } from "vue-sonner";
import { router } from "@inertiajs/vue3";
import { reactive, ref } from "vue";
import AppForm from "@/Components/Shared/forms/AppForm.vue";
import AppFormGroup from "@/Components/Shared/forms/AppFormGroup.vue";
import AppButtonGroup from "@/Components/Shared/button/AppButtonGroup.vue";
import AppButton from "@/Components/Shared/button/AppButton.vue";
import AppReviewedProductSearch from "@/Components/Shared/product/AppReviewedProductSearch.vue";
import AppModalFooter from "@/Components/Shared/modal/AppModalFooter.vue";
import AppProductRow from "@/Components/Shared/product/AppProductRow.vue";

type Props = {
    collection: object;
};

const { collection } = defineProps<Props>();

const emit = defineEmits(["close", "success"]);

const form = reactive({
    product: null,
});
const loading = ref(false);

// methods
const prepareFormData = () => {
    const formData = new FormData();
    formData.append("product", form.product ? form.product.id : null);
    formData.append("collections[]", collection.id);

    return formData;
};

const handleSubmit = () => {
    loading.value = true;

    // set form data
    const formData = prepareFormData();

    axios
        .post(apiPathUrl("/collections/attach"), formData)
        .then(() => {
            emit("success");
            toast.success("Het product is toegevoegd aan je collectie");
            router.reload({
                preserveScroll: true,
            });
        })
        .catch(() => {
            // this.errors = error.response.data.errors;
            toast.error("Er ging iets mis bij het aanpassen van de collectie");
        })
        .finally(() => {
            emit("close");

            loading.value = false;
        });
};

const cancelCollection = () => {
    emit("close");
};

const formId = `add-product-to-collection-${collection.id}`;
</script>

<template>
    <AppForm
        :id="formId"
        @submit.prevent="handleSubmit"
    >
        <AppProductRow
            v-if="form.product"
            :product="form.product"
        >
            <template #options>
                <AppButton
                    icon="cross"
                    icon-size="xsmall"
                    size="xsmall"
                    variant="icon"
                    @click="form.product = null"
                />
            </template>
        </AppProductRow>
        <AppFormGroup v-else>
            <AppReviewedProductSearch
                v-model="form.product"
                label="Product"
                required
                hint="Je kunt enkel aangeraden producten in een collectie plaatsen"
                :collection-id="collection.id"
                :loading="loading"
            />
        </AppFormGroup>

        <AppModalFooter>
            <AppButtonGroup
                variant="spaced"
                class="grow"
            >
                <AppButton @click="cancelCollection"> Annuleren </AppButton>

                <AppButton
                    :form="formId"
                    type="submit"
                    color="primary"
                >
                    Opslaan
                </AppButton>
            </AppButtonGroup>
        </AppModalFooter>
    </AppForm>
</template>
